import { TableCell } from '@mui/material';
import { styled } from "@mui/system";

export const StyledTableCell = styled(TableCell)({
    padding: "4px 8px",
    lineHeight: "1rem",
});